module.exports = __webpack_public_path__ + "static/media/no_image.fd72cd4d.jpg";